import React, { useState } from 'react';
import {
  MenuItem,
  Select,
  FormControl,
  Container,
  InputLabel,
  Stack,
  TextField,
  Box,
  Button,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Modal,
  FormHelperText,
  InputAdornment,
} from '@mui/material';
import InputMask from 'react-input-mask';
import { useForm, Controller } from 'react-hook-form';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { api as dealerApi } from '../store/domains/stock';
import WorkHours from '../components/WorkingHours/WorkingHours';
import Location from '../components/Location/Location';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '13px ',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  boxShadow: 24,
  p: '20px',
};
function DealerCreate() {
  const [selecetedHub, setSelectedHub] = useState({
    hubId: '',
    hibTitle: '',
  });
  const [sucessModal, setSucessModal] = useState(false);
  const [isUserVerified, setIsUserVerirfied] = useState(false);
  const { data: hubList } = dealerApi.useGetHubList();

  const [getUserInfo, { data: userInfo, isLoading }] = dealerApi.useGetUserInfo();

  const [createDealer, { isLoading: createLoading }] = dealerApi.useCreateDealer();

  const {
    control,
    handleSubmit,
    reset: reset1,
  } = useForm({
    defaultValues: {
      idCardNumber: '',
      idCardPin: '',
    },
  });
  const {
    control: finalControl,
    handleSubmit: finalHandleSubmit,
    reset: reset2,
  } = useForm({
    defaultValues: {
      title: '',
      email: '',
      contactNumber: '',
      address: null,
      workingHours: [
        {
          weekdays: [],
          startTime: '',
          endTime: '',
        },
      ],
    },
  });
  const handleClose = () => {
    setSucessModal(false);
    reset1();
    reset2();
    setIsUserVerirfied(false);
  };
  const handleChangeClick = (event) => {
    event.preventDefault();
    setIsUserVerirfied(false);
  };
  const onfinalHandleSubmit = async (data) => {
    let documentNumber;
    let documentSerie;
    if (userInfo.serialNumber.startsWith('AA')) {
      documentNumber = userInfo.serialNumber.slice(2);
      documentSerie = 'AA';
    } else if (userInfo.serialNumber.startsWith('AZE')) {
      documentNumber = userInfo.serialNumber.slice(3);
      documentSerie = 'AZE';
    }
    const finalData = {
      title: data.title,
      ...selecetedHub,
      contactNumbers: [`+994${data.contactNumber.replace(/\s/g, "")}`],
      emails: [`${data.email}`],
      address: data.address,
      workingHours: data.workingHours,
      users: [
        {
          pin: userInfo.pin,
          name: userInfo.name,
          fatherName: userInfo.patronymic,
          surname: userInfo.surname,
          dateOfBirth: userInfo.birthDate,
          placeOfBirth: userInfo.birthPlace,
          nationality: userInfo.nationality,
          document: {
            documentNumber,
            serie: documentSerie,
          },
        },
      ],
    };
    try {
      await createDealer(finalData).unwrap();
      setSucessModal(true);
    } catch (err) {
      console.log('');
    }
  };

  const onUserInfoGetSubmit = async (data) => {
    try {
      await getUserInfo(data).unwrap();
      setIsUserVerirfied(true);
    } catch (error) {
      console.log('');
    }
  };

  const handleChangeSelect = (event) => {
    const { hubTitle } = hubList.find((item) => item.hubId === event.target.value);
    setSelectedHub({
      hubTitle,
      hubId: event.target.value,
    });
  };

  return (
    <Container sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <form style={{ display: 'flex', gap: 20 }}>
     
        <Controller
          name="idCardNumber"
          control={control}
          rules={{
            required: 'ID card number required ' || '',
          }}
          render={({ field, formState: { errors } }) => (
            <Box sx={{ width: '100%' }}>
              <TextField disabled={isUserVerified} label="ID card number" sx={{ width: '100%' }} {...field} />
              {errors?.idCardNumber?.message && <FormHelperText error>{errors?.idCardNumber?.message} </FormHelperText>}
            </Box>
          )}
        />
        <Controller
          name="idCardPin"
          control={control}
          rules={{
            required: 'ID card pin code required ' || '',
          }}
          render={({ field, formState: { errors } }) => (
            <Box sx={{ width: '100%' }}>
              <TextField disabled={isUserVerified} label="ID card pin" sx={{ width: '100%' }} {...field} />

              {errors?.idCardPin?.message && <FormHelperText error>{errors?.idCardPin?.message} </FormHelperText>}
            </Box>
          )}
        />

        {isUserVerified ? (
          <Button onClick={handleChangeClick} sx={{ width: '200px', maxHeight: '56px' }} variant="contained">
            Change
          </Button>
        ) : (
          <Button
            onClick={handleSubmit(onUserInfoGetSubmit)}
            type="submit"
            sx={{ width: '200px', maxHeight: '56px' }}
            variant="contained"
          >
            {isLoading ? 'Processing...' : ' Verify'}
          </Button>
        )}
      </form>
      {isUserVerified && userInfo && (
        <Card
          sx={{
            display: 'flex',
            justifyContent: 'space-between',

            minHeight: '200px',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flex: '1 0 auto' }}>
              <Typography component="div" variant="h5" sx={{ mb: '20px' }}>
                {`${userInfo.surname} ${userInfo.name} ${userInfo.patronymic}`}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                <ul
                  style={{
                    listStyleType: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                  }}
                >
                  <li>
                    <span
                      style={{
                        color: 'black',
                      }}
                    >
                      Serial number :
                    </span>{' '}
                    {userInfo.serialNumber}
                  </li>
                  <li>
                    <span
                      style={{
                        color: 'black',
                      }}
                    >
                      Date of birth :
                    </span>{' '}
                    {userInfo.birthDate}
                  </li>
                  <li>
                    <span
                      style={{
                        color: 'black',
                      }}
                    >
                      Nationality :
                    </span>{' '}
                    {userInfo.nationality}
                  </li>
                </ul>
              </Typography>
            </CardContent>
          </Box>
          <CardMedia
            component="img"
            sx={{ width: 151 }}
            image={`data:image/jpeg;base64,${userInfo.image}`}
            alt="User image"
          />
        </Card>
      )}

      {isUserVerified && userInfo ? (
        <FormControl>
          <form
            style={{ display: 'flex', flexDirection: 'column', gap: 20 }}
            onSubmit={finalHandleSubmit(onfinalHandleSubmit)}
          >
            <Stack direction="row" spacing={2}>
              <Box sx={{ width: '100%' }}>
                <InputLabel id="hub-label">Hub</InputLabel>
                <Select
                  labelId="hub-label"
                  id="hub"
                  label="Hub"
                  value={selecetedHub.hubId}
                  onChange={handleChangeSelect}
                  sx={{
                    width: '100%',
                  }}
                >
                  {hubList?.map(({ hubId, title }) => (
                    <MenuItem key={hubId} value={hubId}>
                      {title}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box sx={{ width: '100%' }}>
                <Controller
                  name="title"
                  control={finalControl}
                  rules={{
                    required: 'Title required ' || '',
                  }}
                  render={({ field, formState: { errors } }) => (
                    <Box
                      sx={{
                        width: '100%',
                      }}
                    >
                      <TextField
                        {...field}
                        sx={{
                          width: '100%',
                        }}
                        id="outlined-basic"
                        label="Ttitle"
                        variant="outlined"
                      />
                      {errors?.title?.message && <FormHelperText error>{errors?.title?.message} </FormHelperText>}
                    </Box>
                  )}
                />
              </Box>
              <Box sx={{ width: '100%' }}>
                <Controller
                  name="email"
                  control={finalControl}
                  rules={{
                    required: 'Email required' || '',
                  }}
                  render={({ field, formState: { errors } }) => (
                    <Box>
                      <TextField
                        {...field}
                        type="email"
                        sx={{
                          width: '100%',
                        }}
                        id="outlined-basic"
                        label="Email"
                        variant="outlined"
                      />
                      {errors?.email?.message && <FormHelperText error>{errors?.email?.message} </FormHelperText>}
                    </Box>
                  )}
                />
              </Box>
              <Box sx={{ width: '100%' }}>
                <Controller
                  name="contactNumber"
                  control={finalControl}
                  rules={{
                    required: 'Contact number required ' || '',
                  }}
                  render={({ field, formState: { errors } }) => (
                    <Box>
                    
                      <InputMask {...field} mask="99 999 99 99" maskChar='' >
                      
                        <TextField
                          sx={{
                            width: '100%',
                          }}
                          id="outlined-basic"
                          label="Contact number"
                          variant="outlined"
                          InputProps={{
                            startAdornment: <InputAdornment position="start">+994</InputAdornment>,
                          }}
                        />
                      </InputMask>
                      {errors?.contactNumber?.message && (
                        <FormHelperText error>{errors?.contactNumber?.message} </FormHelperText>
                      )}
                    </Box>
                  )}
                />
              </Box>
            </Stack>

            <WorkHours control={finalControl} handleSubmit={finalHandleSubmit} />
            <Location control={finalControl} handleSubmit={finalHandleSubmit} />
            <Button sx={{ my: 5 }} type="submit" variant="contained">
              {createLoading ? 'Processing...' : 'Create'}
            </Button>
          </form>
        </FormControl>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            minHeight: '400px',

            borderRadius: '13px',
            border: '1px solid #e7eaed',
          }}
        >
          <ErrorOutlineIcon fontSize="large" />
          <h2>To continue please enter valid data</h2>
        </Box>
      )}

      <Modal
        open={sucessModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Dealer created successfully
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            To leave press close
          </Typography>
          <Button onClick={handleClose} sx={{ mt: '5px' }} variant="contained">
            Close
          </Button>
        </Box>
      </Modal>
    </Container>
  );
}

export default DealerCreate;
